(function () {
  'use strict';

  var STORAGE_KEY = 'pet';
  var header = document.querySelector('[data-custom-header]');
  if (!header) return;

  function getStoredPet() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || 'dog';
    } catch (e) {
      return 'dog';
    }
  }

  function setStoredPet(pet) {
    try {
      window.localStorage.setItem(STORAGE_KEY, pet);
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — state just won't persist */
    }
  }

  function applyPetState(pet) {
    header.setAttribute('data-pet', pet);

    var buttons = header.querySelectorAll('[data-pet-btn]');
    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-pet-btn') === pet;
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function normalizePath(url) {
    try {
      var path = url.indexOf('http') === 0 ? new URL(url).pathname : url;
      return path.replace(/\/$/, '') || '/';
    } catch (e) {
      return url;
    }
  }

  // Switching pet always navigates to that pet's home, from ANY page type —
  // product, collection, blog, search, cart, the homepage itself. Choosing a
  // pet is a change of storefront, so the shopper lands on the chosen pet's
  // home rather than staying on a page belonging to the other pet.
  //
  // (Previously this returned null off-homepage, swapping the header's
  // announcement + nav in place without navigating.)
  function resolveRedirectUrl(targetPet) {
    var dogHome = header.getAttribute('data-dog-homepage') || '/';
    var catHome = header.getAttribute('data-cat-homepage') || '/pages/cats';
    var target = targetPet === 'cat' ? catHome : dogHome;

    // Already on that pet's home: nothing to navigate to, just swap state in
    // place so the click still visibly does something.
    if (normalizePath(window.location.pathname) === normalizePath(target)) return null;

    return target;
  }

  // Decide which pet should be shown as active WHEN THE PAGE FIRST LOADS.
  // The homepage and the configured Cat homepage are each unambiguously
  // tied to one pet — landing on either of them always shows that pet's
  // state, regardless of whatever was remembered from a previous visit.
  // Any other page (collection, product, blog, generic page, search,
  // etc.) has no inherent pet, so it falls back to the shopper's last
  // remembered choice.
  function determineInitialPet() {
    var pageType = header.getAttribute('data-page-type');
    var dogHome = header.getAttribute('data-dog-homepage') || '/';
    var catHome = header.getAttribute('data-cat-homepage') || '/pages/cats';

    var currentPath = normalizePath(window.location.pathname);
    var dogHomePath = normalizePath(dogHome);
    var catHomePath = normalizePath(catHome);

    if (pageType === 'index' || currentPath === dogHomePath) {
      setStoredPet('dog');
      return 'dog';
    }

    if (currentPath === catHomePath) {
      setStoredPet('cat');
      return 'cat';
    }

    return getStoredPet();
  }

  function handleToggleClick(event) {
    var btn = event.target.closest('[data-pet-btn]');
    if (!btn) return;

    var targetPet = btn.getAttribute('data-pet-btn');
    var currentPet = getStoredPet();
    if (targetPet === currentPet) return;

    setStoredPet(targetPet);

    var redirectUrl = resolveRedirectUrl(targetPet);
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    applyPetState(targetPet);
  }

  // Initialize state on load — page context wins over stale localStorage
  applyPetState(determineInitialPet());

  header.addEventListener('click', handleToggleClick);

  // Search bar: wire the category dropdown to Shopify's native tag filter
  // (filter.p.tag) so "Dogs" / "Cats" actually narrows results — requires
  // the relevant products to be tagged "Dog" / "Cat" in Shopify admin.
  var searchForm = header.querySelector('[data-search-bar]');
  if (searchForm) {
    searchForm.addEventListener('submit', function () {
      var scopeSelect = searchForm.querySelector('[data-search-scope]');
      if (!scopeSelect) return;

      var scopeValue = scopeSelect.value;
      var existingTagInput = searchForm.querySelector('input[name="filter.p.tag"]');
      if (existingTagInput) existingTagInput.remove();

      if (scopeValue === 'dog' || scopeValue === 'cat') {
        var tagInput = document.createElement('input');
        tagInput.type = 'hidden';
        tagInput.name = 'filter.p.tag';
        tagInput.value = scopeValue === 'dog' ? 'Dog' : 'Cat';
        searchForm.appendChild(tagInput);
      }
    });
  }
})();
